const AREA_DOO = "道央";
const AREA_DOTOU = "道東";
const AREA_DOHOKU = "道北";
const AREA_DONAN = "道南";

const GENRE_ITALIAN = "イタリアン";
const GENRE_FRENCH = "フレンチ";
const GENRE_IZAKAYA = "居酒屋";
const GENRE_WESTERN = "洋食";
const GENRE_SUSHI = "寿司";
const GENRE_HOTEL = "ホテル・旅館";

const POSITION_KITCHEN_STAFF = "キッチンスタッフ";

const FILTER_POSITION_SERVICE_STAFF = "サービススタッフ";
const FILTER_POSITION_HEAD_CHEF = "料理長";
const FILTER_POSITION_MANAGER = "店長";
const FILTER_POSITION_OTHER = "その他";

const HOKKAIDO_AREA_MAPPING = {
    // 道央エリア
    [AREA_DOO]: [
        '札幌市', '千歳市', '恵庭市', '北広島市', '石狩市', '江別市', '岩見沢市',
        '美唄市', '夕張市', '三笠市', '滝川市', '砂川市', '歌志内市', '深川市',
        '南幌町', '奈井江町', '上砂川町', '由仁町', '長沼町', '栗山町', '月形町',
        '浦臼町', '新十津川町', '妹背牛町', '秩父別町', '雨竜町', '北竜町', '沼田町',
        '幌加内町', '小樽市', '島牧村', '寿都町', '黒松内町', '蘭越町', 'ニセコ町',
        '真狩村', '留寿都村', '喜茂別町', '京極町', '倶知安町', '共和町', '岩内町',
        '泊村', '神恵内村', '積丹町', '古平町', '仁木町', '余市町', '赤井川村',
        '苫小牧市', '室蘭市', '登別市', '伊達市', '豊浦町', '壮瞥町', '白老町',
        '厚真町', '洞爺湖町', '安平町', 'むかわ町'
    ],

    // 道東エリア
    [AREA_DOTOU]: [
        '帯広市', '釧路市', '北見市', '網走市', '根室市', '音更町', '士幌町',
        '上士幌町', '鹿追町', '新得町', '清水町', '芽室町', '中札内村', '更別村',
        '大樹町', '広尾町', '幕別町', '池田町', '豊頃町', '本別町', '足寄町',
        '陸別町', '浦幌町', '釧路町', '厚岸町', '浜中町', '標茶町', '弟子屈町',
        '鶴居村', '白糠町', '別海町', '中標津町', '標津町', '羅臼町', '美幌町',
        '津別町', '斜里町', '清里町', '小清水町', '訓子府町', '置戸町', '佐呂間町',
        '遠軽町', '湧別町', '滝上町', '興部町', '西興部村', '雄武町', '大空町'
    ],

    // 道北エリア
    [AREA_DOHOKU]: [
        '旭川市', '士別市', '名寄市', '富良野市', '鷹栖町', '東神楽町', '当麻町',
        '比布町', '愛別町', '上川町', '東川町', '美瑛町', '上富良野町', '中富良野町',
        '南富良野町', '占冠村', '和寒町', '剣淵町', '下川町', '美深町', '音威子府村',
        '中川町', '幌延町', '稚内市', '猿払村', '浜頓別町', '中頓別町', '枝幸町',
        '豊富町', '礼文町', '利尻町', '利尻富士町', '留萌市', '増毛町', '小平町',
        '苫前町', '羽幌町', '初山別村', '遠別町', '天塩町'
    ],

    // 道南エリア
    [AREA_DONAN]: [
        '函館市', '北斗市', '松前町', '福島町', '知内町', '木古内町', '七飯町',
        '鹿部町', '森町', '八雲町', '長万部町', '江差町', '上ノ国町', '厚沢部町',
        '乙部町', '奥尻町', '今金町', 'せたな町'
    ]
};


export const sapporoConfig = {
    HOKKAIDO_AREA_MAPPING,
    jobs: [],
    filters: {
        area: [AREA_DOO, AREA_DOTOU, AREA_DOHOKU, AREA_DONAN],
        genre: [GENRE_ITALIAN, GENRE_FRENCH, GENRE_IZAKAYA, GENRE_WESTERN, GENRE_SUSHI, GENRE_HOTEL],
        position: [POSITION_KITCHEN_STAFF, FILTER_POSITION_SERVICE_STAFF, FILTER_POSITION_HEAD_CHEF, FILTER_POSITION_MANAGER, FILTER_POSITION_OTHER],
    },

    filtersList: {
        area: [
            { areaName: AREA_DOO, dataClickLabel: 'CT_Jobinformation_エリア-道央' },
            { areaName: AREA_DOTOU, dataClickLabel: 'CT_Jobinformation_エリア-道東' },
            { areaName: AREA_DOHOKU, dataClickLabel: 'CT_Jobinformation_エリア-道北' },
            { areaName: AREA_DONAN, dataClickLabel: 'CT_Jobinformation_エリア-道南' }
        ],
        genre: [
            { genreName: GENRE_ITALIAN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-イタリアン' },
            { genreName: GENRE_FRENCH, dataClickLabel: 'CT_Jobinformation_料理ジャンル-フレンチ' },
            { genreName: GENRE_IZAKAYA, dataClickLabel: 'CT_Jobinformation_料理ジャンル-居酒屋' },
            { genreName: GENRE_WESTERN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-洋食' },
            { genreName: GENRE_SUSHI, dataClickLabel: 'CT_Jobinformation_料理ジャンル-寿司' },
            { genreName: GENRE_HOTEL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ホテル旅館' }
        ],
        position: [
            { positionName: POSITION_KITCHEN_STAFF, dataClickLabel: 'CT_Jobinformation_職種-キッチンスタッフ' },
            { positionName: FILTER_POSITION_SERVICE_STAFF, dataClickLabel: 'CT_Jobinformation_職種-サービススタッフ' },
            { positionName: FILTER_POSITION_HEAD_CHEF, dataClickLabel: 'CT_Jobinformation_職種-料理長' },
            { positionName: FILTER_POSITION_MANAGER, dataClickLabel: 'CT_Jobinformation_職種-店長' },
            { positionName: FILTER_POSITION_OTHER, dataClickLabel: 'CT_Jobinformation_職種-その他' }
        ],
    },

    parameterMapping: {
        area: {
            "道央": { city_id: 1 },
            "道東": { city_id: 20 },
            "道北": { city_id: 13 },
            "道南": { city_id: 11 },
        },
        genre: {
            [GENRE_ITALIAN]: { genre_id: 1 },
            [GENRE_FRENCH]: { genre_id: 2 },
            [GENRE_IZAKAYA]: { genre_id: 11 },
            [GENRE_WESTERN]: { genre_id: 4 },
            [GENRE_SUSHI]: { genre_id: 7 },
            [GENRE_HOTEL]: { genre_id: 23 },
        },
        position: {
            [POSITION_KITCHEN_STAFF]: { occupation_id: 4 },
            [FILTER_POSITION_SERVICE_STAFF]: { occupation_id: 3 },
            [FILTER_POSITION_HEAD_CHEF]: { occupation_id: 2 },
            [FILTER_POSITION_MANAGER]: { occupation_id: 1 },
            [FILTER_POSITION_OTHER]: { occupation_id: 30 },
        }
    },

    jobInformationData: {
        dataClickLabels: {
            area: 'CT_Jobinformation_エリア',
            genre: 'CT_Jobinformation_料理ジャンル',
            position: 'CT_Jobinformation_職種',
        }
    },

    faqData: [
        {
            id: 1,
            question: '本当にお金はかかりませんか？',
            answer: 'はい。弊社のサービスにつきまして、お金は一切かかりません。ご利用して頂いた求職者様の中には「面接を受けたら、入社したらお金が発生する」と思っている方もいらっしゃいますが、そういったこともございませんのでご安心くださいませ。ただし、面談や面接にお越しいただく際の交通費は実費でのご負担になりますのでご了承下さいませ。',
            dataClickLabel: 'CT_Question_Accordion-1st'
        },
        {
            id: 2,
            question: '在職中で、まだ転職を検討中ですが利用しても大丈夫ですか？',
            answer: 'もちろん大丈夫です。在職中の方からも多くご相談いただいておりまして、面接日も弊社が求職者様のスケジュールにあわせて調整していきます。入社日につきましても、現職先の退社日にあわせて、弊社が代わって転職先の企業様と調整いたします。',
            dataClickLabel: 'CT_Question_Accordion-2nd'
        },
        {
            id: 3,
            question: '全然時間がなくて、面談はそちらへ行かないとダメですか？',
            answer: '基本的にはご来社いただいて、面談でキャリアアドバイザーと直接お話しした方がスムーズに進めますが、現在ではテレビ電話のアプリを利用したWEB面談も実施しております。新型コロナウイルス感染症の一件もございますので、感染を懸念される方や時間が全くない方に関しましてはご予約の際に伝えていただけますと幸いです。',
            dataClickLabel: 'CT_Question_Accordion-3rd'
        },
        {
            id: 4,
            question: '早めに仕事がしたいのですが、どれくらいで転職できますか？',
            answer: '企業様のスケジュールにもよりますが、大体1～2週間くらいをみていただければと思います。しかし、ケースによっては面談した日に面接、その場で内定をいただいて入社！という最速１日で転職できることもありますので、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-4th'
        },
        {
            id: 5,
            question: '内定をいただいたところに必ず入社しないといけないのでしょうか？',
            answer: '必ず入社する必要はございません。企業への辞退連絡に関しても、弊社の方で対応しますので、ご安心ください。また、複数の企業を受けて内定をいくつかいただいていて迷われている場合も、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-5th'
        },
    ],

    footerData: {
        companyInfo: '株式会社クオレガ\nフーズラボエージェント\n〒105-0004東京都港区新橋1丁目10-6\n新橋M-SQUARE11階',
        licenseInfo: '厚生労働大臣許可番号有料職業紹介事業許可番号\n13-ユ-308506\n',
        dataClickLabels: {
            pageTop: 'FT_FooterArea_PageTop',
            termsOfService: 'FT_FooterArea_利用規約',
            privacyPolicy: 'FT_FooterArea_プライバシーポリシー'
        }
    },

    officeData: [
        {
            id: 1,
            name: 'tokyo',
            image: '/renewal_lp/Office/office_tokyo.png',
            alt: '東京本社 東京都港区新橋1丁目10-6新橋M-SQUARE11F',
            title: '東京本社',
            address: '東京都港区新橋1丁目10-6\n新橋M-SQUARE11F',
        },
        {
            id: 2,
            name: 'kansai',
            image: '/renewal_lp/Office/office_kansai.png',
            alt: '関西支社 大阪府大阪市北区梅田2丁目4-9ブリーゼタワー17F',
            title: '関西支社',
            address: '大阪府大阪市北区梅田2丁目4-9\nブリーゼタワー17F',
        },
        {
            id: 3,
            name: 'nagoya',
            image: '/renewal_lp/Office/office_nagoya.png',
            alt: '名古屋支社 愛知県名古屋市中村区名駅3丁目28-12大名古屋ビルヂング11階',
            title: '名古屋支社',
            address: '愛知県名古屋市中村区名駅3丁目28-12\n大名古屋ビルヂング11階',
        },
        {
            id: 4,
            name: 'fukuoka',
            image: '/renewal_lp/Office/office_fukuoka.png',
            alt: '福岡支社 福岡県福岡市中央区天神1丁目13-17福岡天神1丁目ビル7階',
            title: '福岡支社',
            address: '福岡県福岡市中央区天神1丁目13-17\n福岡天神1丁目ビル7階',
        },
        {
            id: 5,
            name: 'sapporo',
            image: '/renewal_lp/Office/office_sapporo.png',
            alt: '札幌支社 北海道札幌市中央区南1条西5丁目20郵政福祉札幌第一ビル4階',
            title: '札幌支社',
            address: '北海道札幌市中央区南1条西5丁目20\n郵政福祉札幌第一ビル4階',
        },
    ],
    stepFormLabels: {
        step0: {
            dataViewLabel: 'EF_StepForm_Step0-転職意欲',
            dataClickLabels: {
                high: 'EF_StepForm_Step0-転職意欲-転職したい',
                moderate: 'EF_StepForm_Step0-転職意欲-情報収集',
                close: 'EF_StepForm_Step0-閉じる',
                blank: 'EF_StepForm_Step0-空白',
            }
        },
        step1: {
            dataViewLabel: 'EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'EF_StepForm_Step1-現在の状況-離職中',
            }
        },
        step2: {
            dataViewLabel: 'EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'EF_StepForm_Step2-経験年数-10年以上',
                back: 'EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'EF_StepForm_Step3-お住まい-戻る',
                next: 'EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'EF_StepForm_Step4-名前年齢-戻る',
                next: 'EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'EF_StepForm_Step5-連絡先-戻る',
                link: 'EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'EF_StepForm_Step5-連絡先-CVボタン'
            }
        },
    },
}